module.exports = __webpack_public_path__ + "assets/a692a9a076e5553bdd0fe749f36bb04b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/buttons/denoms/denom_50.mp3
 ** module id = 48
 ** module chunks = 0
 **/